module.exports = __webpack_public_path__ + "static/person2-4b35a734f819d4c3d25204dec21361d8.png";